/**
 * The ten actions as people say them. The server sends the same words with
 * the registry; this copy is for lines built from what the server already
 * sent, such as an access list, so a screen never shows "post" or "reverse".
 */
export const ACTION_LABEL: Record<string, string> = {
  read: 'See',
  create: 'Add',
  update: 'Change',
  delete: 'Delete',
  post: 'Make final',
  approve: 'Approve',
  reject: 'Reject',
  reverse: 'Undo a final record',
  export: 'Download',
  print: 'Print',
};

/** The order the grid's columns and every list use. */
export const ACTION_ORDER = [
  'read',
  'create',
  'update',
  'delete',
  'post',
  'approve',
  'reject',
  'reverse',
  'export',
  'print',
];

/** "inv.sku.create" → "Add", for a code with nothing else to go on. */
export function actionWord(code: string): string {
  const action = code.split('.')[2] ?? code;
  return ACTION_LABEL[action] ?? action;
}
